import React from "react";
import "./Card.scss"
import "./StryfeHeader.scss"

const StryfeHeader = () => {
    return (
        <div>
            <div className='stryfe-header'>
                <div className='stryfe-header-title'>Senna</div>
            </div>
        </div>
    )
}

export default StryfeHeader;